export default "__VITE_ASSET__C_N9loAV__"